import { countLimitedSwatchUnits, notifySwatchLimit, SWATCH_LIMIT } from '@theme/swatch-limit';

const bypassedForms = new WeakSet();
const bypassedLinks = new WeakSet();
let validationPromise = null;

function getCart() {
  if (!validationPromise) {
    validationPromise = fetch(`${Theme.routes.cart_url}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart validation failed with status ${response.status}`);
        return response.json();
      })
      .finally(() => {
        validationPromise = null;
      });
  }

  return validationPromise;
}

async function cartExceedsSwatchLimit() {
  try {
    const cart = await getCart();
    return countLimitedSwatchUnits(cart.items) > SWATCH_LIMIT;
  } catch (error) {
    console.error('[Swatch limit] Unable to validate the cart before checkout:', error);
    return false;
  }
}

function isCheckoutForm(form, submitter) {
  if (!(form instanceof HTMLFormElement)) return false;
  if (submitter?.name === 'checkout') return true;
  return Boolean(form.querySelector('[name="checkout"]'));
}

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!isCheckoutForm(form, event.submitter)) return;

  if (bypassedForms.has(form)) {
    bypassedForms.delete(form);
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();

  if (await cartExceedsSwatchLimit()) {
    notifySwatchLimit();
    return;
  }

  bypassedForms.add(form);
  if (event.submitter instanceof HTMLElement) {
    form.requestSubmit(event.submitter);
  } else {
    form.requestSubmit();
  }
}, true);

document.addEventListener('click', async (event) => {
  const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
  const link = path.find((node) => node instanceof HTMLAnchorElement && /\/checkout(?:[/?#]|$)/.test(node.href));
  if (!link || bypassedLinks.has(link)) {
    if (link) bypassedLinks.delete(link);
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();

  if (await cartExceedsSwatchLimit()) {
    notifySwatchLimit();
    return;
  }

  bypassedLinks.add(link);
  link.click();
}, true);
